<template>
</template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        width: {
          name: 'width',
          defaultValue: '100',
          min: '30',
          max: '600',
          labelDesc: 'width',
          callback: function() {
            console.log(this);
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + 'px';
          }
        },
        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';
          }
        },
        titleStyle: {
          name: 'blogTitleStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          // showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blogTitleStyle',
          callback: function () {

            vm.resources.titleStyle.defaultFamily = this.family;
            vm.element.internal_config.titleStyle.family = this.family;

            vm.resources.titleStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.titleStyle.size = this.size + 'px';

            vm.resources.titleStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.titleStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.titleStyle.defaultColor = this.color;
            vm.element.internal_config.titleStyle.color = this.color;

            vm.resources.titleStyle.defaultAlign = this.align;
            vm.element.internal_config.titleStyle.align = this.align;

            vm.resources.titleStyle.defaultWeight = this.weight;
            vm.element.internal_config.titleStyle.weight = this.weight;

            vm.resources.titleStyle.defaultStyle = this.style;
            vm.element.internal_config.titleStyle.style = this.style;

            vm.resources.titleStyle.defaultStroke = this.stroke;
            vm.element.internal_config.titleStyle.stroke = this.stroke;
          }
        },
        subTextStyle: {
          name: 'subTextContent',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          // showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blogTitleStyle',
          callback: function() {

            vm.resources.subTextStyle.defaultFamily = this.family;
            vm.element.internal_config.subTitleStyle.family = this.family;

            vm.resources.subTextStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.subTitleStyle.size = this.size + 'px';

            vm.resources.subTextStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.subTitleStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.subTextStyle.defaultColor = this.color;
            vm.element.internal_config.subTitleStyle.color = this.color;

            vm.resources.subTextStyle.defaultAlign = this.align;
            vm.element.internal_config.subTitleStyle.align = this.align;

            vm.resources.subTextStyle.defaultWeight = this.weight;
            vm.element.internal_config.subTitleStyle.weight = this.weight;

            vm.resources.subTextStyle.defaultStyle = this.style;
            vm.element.internal_config.subTitleStyle.style = this.style;

            vm.resources.subTextStyle.defaultStroke = this.stroke;
            vm.element.internal_config.subTitleStyle.stroke = this.stroke;

          }
        },
        backgroundColor: {
          name: 'backgroundColor',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'background-color',
          callback: function() {
            vm.resources.backgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.backgroundColor = this.colorValue;
          }
        },
        iconHoverColor: {
          name: 'backgroundColorHover',
          defaultValue: '#000',
          gradient: false,
          labelDesc: 'icon-color',
          callback: function() {
            document.documentElement.style.setProperty('--BlogAuthorCardComponent-icon-hover',this.colorValue);
            vm.resources.iconHoverColor.defaultValue = this.colorValue;
            vm.element.internal_config.emailColorIcon = this.colorValue;
            vm.element.internal_config.facebookColorIcon = this.colorValue;
            vm.element.internal_config.instagramColorIcon = this.colorValue;
            vm.element.internal_config.twitterColorIcon = this.colorValue;
            vm.element.internal_config.linkedinColorIcon = this.colorValue;
            vm.element.internal_config.youtubeColorIcon = this.colorValue;
            vm.element.internal_config.mediumColorIcon = this.colorValue;
          }
        }
      }
    };
  },
  methods: {
    setMinValuesData(resource, value) {
      this.resources[resource].min = parseInt(value);
    },
    setValuesData(data) {
      this.element = data;
      this.resources.width.defaultValue = data.internal_config.width;
      this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
      this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
      this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
      this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
      // this.resources.theme.defaultValue = data.internal_config.theme;

      this.resources.titleStyle.defaultFamily = data.internal_config.titleStyle.family;
      this.resources.titleStyle.defaultSize = data.internal_config.titleStyle.size;
      this.resources.titleStyle.defaultSizeMobile = data.internal_config.titleStyle.sizeMobile;
      this.resources.titleStyle.defaultColor = data.internal_config.titleStyle.color;
      this.resources.titleStyle.defaultAlign = data.internal_config.titleStyle.align;
      this.resources.titleStyle.defaultWeight = data.internal_config.titleStyle.weight;
      this.resources.titleStyle.defaultStyle = data.internal_config.titleStyle.style;
      this.resources.titleStyle.defaultStroke = data.internal_config.titleStyle.stroke;


      this.resources.subTextStyle.defaultFamily = data.internal_config.subTitleStyle.family;
      this.resources.subTextStyle.defaultSize = data.internal_config.subTitleStyle.size;
      this.resources.subTextStyle.defaultSizeMobile = data.internal_config.subTitleStyle.sizeMobile;
      this.resources.subTextStyle.defaultColor = data.internal_config.subTitleStyle.color;
      this.resources.subTextStyle.defaultAlign = data.internal_config.subTitleStyle.align;
      this.resources.subTextStyle.defaultWeight = data.internal_config.subTitleStyle.weight;
      this.resources.subTextStyle.defaultStyle = data.internal_config.subTitleStyle.style;
      this.resources.subTextStyle.defaultStroke = data.internal_config.subTitleStyle.stroke;

      this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;
      this.resources.iconHoverColor.defaultValue = data.internal_config.emailColorIcon;
      // this.resources.imageHeight.defaultValue = parseInt(data.internal_config.imageHeight.replace('px', ''));
    },
    getOptions() {
      return [
        {name: '01', value: '01', selected: 'selected', disabled: false},
        {name: '02', value: '02', selected: false, disabled: false},
        {name: '03', value: '03', selected: false, disabled: false},
        {name: '04', value: '04', selected: false, disabled: false}
      ];
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/AuthorCard/Resources.vue